module.exports = __webpack_public_path__ + "img/logo-new.e6a46e10.webp";